import ExerciseTagContext from './ExerciseTagContext';

export default ExerciseTagContext;
export * from './withExerciseTagContext';
